import { breadcrumbsCharacterLimit, slugsToReplace, pagesWithoutBreadcrumbs } from './constants';
import { pushCustomEvent } from 'utils/analytics';
import { AD_PAGES_PREFIX } from 'define';

export function getPathnameWithoutAdPrefix(pathname) {
  if (pathname !== AD_PAGES_PREFIX && !pathname.startsWith(`${AD_PAGES_PREFIX}/`)) {
    return pathname;
  }

  return pathname.slice(AD_PAGES_PREFIX.length) || '/';
}

export function calculateTitleLengthLimit(title) {
  if (title.length > breadcrumbsCharacterLimit) {
    const newLimit = `${(breadcrumbsCharacterLimit / title.length) * 100}%`;

    return newLimit;
  }

  return '100%';
}

export function getUrl(pathSegments, i, raw = false) {
  const rawUrl = pathSegments.slice(0, i + 1);
  if (raw) return rawUrl.join('/') || '/';
  return rawUrl.map(s => slugsToReplace[s] || s).join('/') || '/';
}

export function getBreadcrumbs(locationPathname, breadcrumbsMap, validPages) {
  const pathname = getPathnameWithoutAdPrefix(locationPathname);
  const isPageWithoutBreadcrumbs = pagesWithoutBreadcrumbs.some(path => pathname.includes(path));

  if (pathname === '/' || isPageWithoutBreadcrumbs) return null;

  const pathSegments = pathname.split('/');

  return pathSegments.reduce((acc, segment, i) => {
    const rawUrl = getUrl(pathSegments, i, true);
    const url = getUrl(pathSegments, i);
    const current = i === pathSegments.length - 1;

    if (!current && !validPages.includes(rawUrl) && !validPages.includes(url)) return acc;

    const el = slugsToReplace[segment] || segment;
    const title = breadcrumbsMap[`/${el}`] || el;

    acc.push({ url, title, current });
    return acc;
  }, []);
}

export function pushBreadcrumbsEvent({ url, title, deviceType }) {
  pushCustomEvent('ndrsn_breadcrumbs', {
    action: 'click_breadcrumb',
    label: title,
    pageUrl: window.location.href,
    targetUrl: url,
    deviceType,
  });
}
